export default __webpack_public_path__ + "static/CoolingCenters-c6e1dbfb1194445d1c3770dd5213d3d8.png";